import type {Features} from '@/types/features.types';

export const myparcel_italie: Features = {
  debug: {
    websockets: false,
  },
  events: {
    sknj: {
      endOfYear: false,
    },
  },
  errors: false,
  portal: {
    events: false,
  },
  page: {
    addresses: {
      import: true,
    },
    collectTrip: false,
    dashboard: true,
    deliveries: true,
    orders: {
      create: true,
      import: true,
      overview: true,
      editPackageForm: true,
    },
    prices: {
      scale: {
        dhl: false,
        dpd: false,
        postnl: false,
      },
    },
    products: {
      import: true,
    },
    settings: {
      shop: {
        emails: true,
        general: false,
        orders: true,
        returns: {
          index: false,
        },
        rules: {
          index: true,
          orders: true,
          shipments: true,
          returns: true,
        },
        // Feature flag is NOT used to turn on the sales-channel features. It is used to bypass the fulfilment checks to access saleschannel.
        salesChannels: true,
        trackTrace: false,
      },
    },
    shipments: {
      newShipmentOverview: false,
      newCreateShipmentForm: true,
      newImportShipmentForm: false,
      newCreateReturnShipmentForm: false,
    },
    users: false,
  },
  settings: {
    accountSettingsLegacy: false,
  },
  trackAndTraceModal: false,
} as const;
